import React from 'react';
import { Gamepad2, Brain, Sparkles } from 'lucide-react';

const About = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-blue-600 px-8 py-12 text-center text-white">
          <h1 className="text-4xl font-bold mb-4">Our Mission</h1>
          <p className="text-blue-100 text-lg max-w-2xl mx-auto">
            Making mathematics accessible, engaging, and enjoyable for everyone.
          </p>
        </div>
        
        <div className="p-8 md:p-12">
          <div className="max-w-3xl mx-auto text-center space-y-8">
            <div className="text-xl md:text-2xl font-medium text-gray-800 leading-relaxed">
              "Learning math should be fun. In addition to solving questions on paper, 
              we should also be able to learn math concepts through play."
            </div>

            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="flex flex-col items-center p-4">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 text-blue-600">
                  <Gamepad2 className="w-8 h-8" />
                </div>
                <h3 className="font-bold text-gray-800 mb-2">Learn Through Play</h3>
                <p className="text-gray-600 text-sm">
                  Interactive games that demonstrate mathematical principles in action.
                </p>
              </div>

              <div className="flex flex-col items-center p-4">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 text-purple-600">
                  <Brain className="w-8 h-8" />
                </div>
                <h3 className="font-bold text-gray-800 mb-2">Build Strategy</h3>
                <p className="text-gray-600 text-sm">
                  Develop critical thinking and logical reasoning skills.
                </p>
              </div>

              <div className="flex flex-col items-center p-4">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4 text-yellow-600">
                  <Sparkles className="w-8 h-8" />
                </div>
                <h3 className="font-bold text-gray-800 mb-2">Have Fun</h3>
                <p className="text-gray-600 text-sm">
                  Discover the joy and beauty of mathematics.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
